<template>
    <edit :orderNumber="orderNumber"></edit>
</template>
<script>
import edit from './order_detail.vue'

export default {
    name: 'cash_order_detail',

    props: {
        orderNumber: String
    },

    components: {
        edit
    }
}
</script>